import BrandLogo from "../../atoms/brandLogo";
import { numberFormat } from "../../../utils";
import wave from "../../../assets/images/waves pattern.svg";

// import Download from "../../assets/images/Download.svg";
// import Copy from "../../assets/images/Copy.svg";
import { useNavigate } from "react-router-dom";
import {
  Container,
  HeaderImage,
  Logo,
  Card,
  SubDiv,
  Note,
  Total,
  ConfirmButton,
} from "./styles";

function PaymentReciept({
  profile,
  checkoutData,
  setReceipt,
  selectedFile,
  hero
}: any) {
  const navigate = useNavigate();

  const submitHandler = (data: any) => {
    setReceipt(false);
    navigate(-1);
  };

  // const handleDownload = () => {
  //   // Replace 'your-pdf-file.pdf' with the actual path or URL of your PDF file.
  //   const pdfFile = selectedFile;
  //   const blob = new Blob([pdfFile], { type: "application/pdf" });
  //   const url = window.URL.createObjectURL(blob);

  //   // Create a link element and trigger a click event to download the file.
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = `spendbox-receipt-${selectedFile?.name}.pdf`; // Specify the downloaded file name.
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  return (
    <Container className="bg-#FFF] px-[5%]  ">
      <HeaderImage>
        <img src={hero ? hero.headerImage : wave} alt="" />
      </HeaderImage>
      <Logo>
        <BrandLogo src={profile?.image} />
      </Logo>
      <Card>
        <h1>Receipt</h1>
        <SubDiv>
          <h2>Subtotal Bill</h2>
          <p>{numberFormat(checkoutData.amount)}</p>
        </SubDiv>
        <SubDiv>
          <h2>From</h2>
          <p className="text-[0.875em]">{checkoutData.phoneNumber}</p>
        </SubDiv>
        <Note>
          <h2>Note</h2>
          <p>{checkoutData?.note}</p>
        </Note>

        <Total>
          <h2>Total</h2>
          <h2>{numberFormat(checkoutData.amount)}</h2>
        </Total>
        {/* <PaymentSubHeading>Payment Reciept</PaymentSubHeading> */}
        {/* <Document onClick={handleDownload}>
          <p>{selectedFile.name}</p>
          <img src={Download} alt="download" />
        </Document> */}
        <ConfirmButton onClick={submitHandler}>
          Contact {profile?.name}
        </ConfirmButton>
        {/* <Document>
          <p>Copy Receipt Page Link</p>
          <img src={Copy} alt="download" />
        </Document> */}
      </Card>
    </Container>
  );
}

export default PaymentReciept;
